export const employeeListCSVAPISortParamsMap: { [key: string]: string } = {
  name: "employeeName",
  surname: "employeeSurname",
  team: "team",
  employedSince: "employedSince",
  position: "position",
  positionCategory: "positionCategory",
  location: "location",
};
